export default __webpack_public_path__ + "static/media/PS5-2.22c61321.jpg";